import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M33.04 3.87001C27.59 0.240015 19.81 2.08999 13.88 8.65999C-0.820025 24.95 1.15997 49.83 1.15997 49.83C1.15997 49.83 0.499958 42.56 3.79996 41.46C8.22996 39.98 11.07 47.29 11.07 47.29C11.07 47.29 12.17 41.68 14.21 34.08C17.54 21.66 19.99 19.22 19.99 19.22H46.25C46.25 19.22 48.56 21.7 52.03 34.08C53.19 38.23 56.21 47.29 56.21 47.29C56.21 47.29 58.14 41 62.37 41.72C64.69 42.11 66.01 45.31 66.01 49.16C66.01 49.16 67.99 27.58 54.01 8.76003C48.18 0.91003 38.65 0.230005 33.2 3.86001H33.04V3.87001Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M29.7399 15.1C28.0699 14.39 26.3799 14.5499 25.0499 15.2799C23.6899 15.9999 22.6099 17.2299 21.5999 18.5199C21.1399 19.2099 20.6099 19.8499 20.1899 20.5899C19.7299 21.2999 19.2899 22.0199 18.8699 22.7799C17.9799 24.2599 17.21 25.82 16.2 27.32C16.43 25.55 16.7999 23.79 17.4599 22.12C17.7199 21.26 18.1599 20.4599 18.5499 19.6499C18.9199 18.8199 19.4899 18.08 19.9999 17.32C21.1299 15.87 22.5599 14.48 24.4599 13.85C26.3299 13.16 28.5899 13.68 29.7399 15.1Z"
        fill={outline}
      />
      <path
        d="M36.51 15.0999C37.66 13.6799 39.92 13.1599 41.79 13.8399C43.69 14.4699 45.12 15.8599 46.25 17.3099C46.76 18.0699 47.33 18.82 47.7 19.64C48.09 20.46 48.53 21.2499 48.79 22.1099C49.45 23.7799 49.82 25.5399 50.05 27.3099C49.04 25.8099 48.27 24.2499 47.38 22.7699C46.97 22.0099 46.52 21.2899 46.06 20.5799C45.65 19.8299 45.12 19.2 44.65 18.51C43.64 17.23 42.56 15.9899 41.2 15.2699C39.87 14.5499 38.18 14.3899 36.51 15.0999Z"
        fill={outline}
      />
      <path d="M32.3699 19.72L33.3699 5.84998L34.3699 19.72H32.3699Z" fill={outline} />
      <path
        d="M16.58 15.9299C15.33 17.9699 14.4401 20.1999 13.6401 22.4399C12.8501 24.6899 12.2301 26.9999 11.6901 29.3099C11.1401 31.6299 10.7401 33.9799 10.3701 36.3299L9.91006 39.8699L9.56006 43.4199L8.07007 43.2599L8.61005 39.6899L9.27005 36.14C9.77005 33.79 10.2901 31.4399 10.9701 29.1299C11.6301 26.8199 12.3801 24.5299 13.2901 22.3099C14.2101 20.0899 15.22 17.8999 16.58 15.9299Z"
        fill={outline}
      />
      <path
        d="M9.9801 21.87C8.9901 25.03 8.20009 28.24 7.59009 31.47C6.99009 34.7 6.5801 37.98 6.6001 41.21L5.1001 41.17C5.3301 37.79 6.0001 34.51 6.8501 31.3C7.7201 28.1 8.7501 24.94 9.9801 21.87Z"
        fill={outline}
      />
      <path
        d="M53.24 20.88C54.19 22.48 54.98 24.17 55.7 25.89C56.42 27.61 57.05 29.37 57.62 31.15C58.16 32.94 58.67 34.74 59.07 36.57C59.49 38.4 59.81 40.24 60.1 42.1L58.61 42.27C58.45 40.44 58.26 38.61 57.97 36.79C57.7 34.97 57.32 33.16 56.9 31.36C56.46 29.57 55.95 27.79 55.36 26.03C54.75 24.27 54.08 22.54 53.24 20.88Z"
        fill={outline}
      />
    </g>
  )
}
